import React, { useEffect, useState } from 'react'
import { Chip } from '@mui/material'
import GroupedMultiSelect from './GroupedMultiSelect'

/**
 * Multi-select for vehicle categories (SIPP), grouped by Vehicle Class.
 * Each Vehicle Class header acts as a select-all for its ACRISS codes.
 * Loads /api/my-business/catalog/categories once on mount. Emits an
 * array of SIPP codes.
 *
 *   <CategorySlicer value={['ECMR','EDMR']} onChange={sipps => ...}/>
 */
export default function CategorySlicer({ value, onChange, sx }) {
	const [options, setOptions] = useState([])

	useEffect(() => {
		fetch('/api/my-business/catalog/categories', { credentials: 'include' })
			.then(r => r.ok ? r.json() : Promise.reject(new Error(`HTTP ${r.status}`)))
			.then(setOptions)
			.catch(() => setOptions([]))
	}, [])

	return (
		<GroupedMultiSelect
			label="Categories (SIPP)"
			options={options}
			value={value}
			getOptionId={o => o.sipp_code}
			getOptionLabel={o => o.name ? `${o.sipp_code} · ${o.name}` : o.sipp_code}
			groupBy={o => o.vehicle_class || 'Unclassified'}
			onChange={onChange}
			renderTag={(o, tagProps) => (
				<Chip {...tagProps} key={o.sipp_code} size="small" label={o.sipp_code}/>
			)}
			sx={sx}
		/>
	)
}
